import { adaptEducationRequestPayload } from "../../infrastructure/adapters/adaptEducationRequestPayload";
import { acceptEducationRequest } from "../../infrastructure/repository/request-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { translate as t } from "../../infrastructure/translate/localization";

export default async function approveHHRREducationRequest({
  companyId,
  requestId,
  employeeAmount,
  companyAmount,
}: {
  companyId: string;
  requestId: string;
  employeeAmount: number;
  companyAmount: number;
}): Promise<void> {
  const adaptedPayload = adaptEducationRequestPayload({
    employeeAmount,
    companyAmount,
  });
  try {
    await acceptEducationRequest({
      splitBy: null,
      companyId,
      requestId,
      ...adaptedPayload,
    });
    showSuccessMessage(
      t("recurrent-payments-section.hhrr-request-approved-successfully")
    );
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
